import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
export const getBackground = (self) => {
  const background = self._getBackgroundThrowable();
  return background.toVO();
};
